{
  "de": {
    "tools_meta": {
      "ai_chat_prefix": "KI-Chat",
      "ai_converters_prefix": "KI Multimedia Tool",
      "ai_document_qas_prefix": "PDF Chat",
      "ai_feedbacks_prefix": "Korrekturhilfe",
      "ai_images_prefix": "Bild generieren",
      "ai_mini_tools_prefix": "KI Promptlabor",
      "ai_assistants_prefix": "KI-Assistenten",
      "ai_personas_prefix": "KI Rollenspiel",
      "audio_recorder_prefix": "Audio-Aufnahmen",
      "file_sharing_prefix": "Datei teilen",
      "link_shortener_prefix": "Link kürzen",
      "pinboard_prefix": "Pinnwand",
      "pupil_feedback_prefix": "KI Feedback",
      "qrcodes_prefix": "QR-Code erstellen",
      "school_class_prefix": "Klassenräume",
      "screen_recorder_prefix": "Bildschirm-Aufnahmen",
      "surveys_prefix": "Umfragen",
      "teaching_board_prefix": "Digitale Tafeln",
      "text_editor_prefix": "Texteditor",
      "title": "KI-Tools, Fortbildungen & Materialien für Lehrkräfte",
      "video_recorder_prefix": "Video-Aufnahmen",
      "website_prefix": "Webseiten",
      "word_clouds_prefix": "Wortwolken",
      "worksheet_prefix": "Arbeitsblatt"
    }
  }
}
